import { useMutation } from 'react-query';
import { setTeamAttribute } from '../services/api/SetTeamAttribute';

type Props = {
  attribute: string;
  type: string;
  value: string;
};

/**
 * `updated_by` is intentionally not sent — user-v2-service resolves the acting
 * admin from the gRPC metadata attached by the BFF, the same way
 * EnterPendingRenewalStatus omits `id_initiator`.
 */
const useSetTeamAttribute = (idTeam: number) => {
  const setTeamAttributeQuery = useMutation(setTeamAttribute);

  const onSubmit = ({ attribute, type, value }: Props) =>
    setTeamAttributeQuery.mutateAsync({
      id_team: idTeam,
      attribute,
      type,
      value,
    });

  return {
    onSubmit,
    isLoading: setTeamAttributeQuery.isLoading,
  };
};

export default useSetTeamAttribute;
